export default __webpack_public_path__ + "static/media/header.7be7f86f.svg";